import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton, DSModal } from '@repo/design-system/index'
import { useEffect } from 'react'
import { useEventTracking } from '../../../helpers/gtmHelper'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { n_onboarding } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'

const EVENT_PAGE_NAME = 'landing_onboarding_profile'
const EVENT_CONTEXT = 'intro'

const ProfileEnterModal = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation()
  const appRouter = useAppRouter()
  const { sendPageViewEvent } = useEventTracking()

  const handleEnterProfileClick = () => {
    appRouter.push('/student/landing/profile')
  }

  const handleLaterClick = () => {
    appRouter.push('/student/auth/new')
  }

  useEffect(() => {
    sendPageViewEvent({ page_name: EVENT_PAGE_NAME, object_context: EVENT_CONTEXT })
  }, [])

  return (
    <DSModal id="TextOnlySMTwoButtonVerticalPopup" isOpen={isOpen} setIsOpen={setIsOpen} size={'lg'}>
      <DSModal.Content>
        <section className="flex flex-col gap-y-[64px] mb-12 items-center">
          <section className="flex flex-col items-center Headline2-24Bd">
            <span className="Body1-16Md">{t(n_onboarding.landing.subhead)}</span>
            <span className="text-center">{t(n_onboarding.landing.title4)}</span>
          </section>
          <section>
            <img src="https://d38emex6h5e12i.cloudfront.net/2024-image/1717045667633_profile-enter.png" alt="profile" />
          </section>
        </section>
        <span className="pl-16 Body2-14Md text-left text-gray-500">{t(n_onboarding.landing.caption_3)}</span>
      </DSModal.Content>
      <DSModal.ButtonContainer direction="vertical">
        <DSButton className="mb-12" size={BUTTON_SIZE.LG} onClick={handleEnterProfileClick}>
          <DSButton.Label>
            <span>{t(n_onboarding.landing.btn_3)}</span>
          </DSButton.Label>
        </DSButton>
        <DSButton size={BUTTON_SIZE.LG} type={BUTTON_TYPE.TEXT} customBgColor={COLORS.WHITE} onClick={handleLaterClick}>
          <DSButton.Label className="text-gray-500">
            <span>{t(n_onboarding.landing.btn_2)}</span>
          </DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export default ProfileEnterModal
